import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">{contactData.intro}</p>

          <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <a
                href={`mailto:${contactData.email}`}
                className="flex flex-col items-center text-center p-5 rounded-lg hover:bg-background-50 transition-colors duration-200 cursor-pointer"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <span className="text-xs font-medium text-foreground-500 mb-1">电子邮箱</span>
                <span className="text-sm text-foreground-900 font-medium break-all">{contactData.email}</span>
              </a>

              <div className="flex flex-col items-center text-center p-5 rounded-lg">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </span>
                <span className="text-xs font-medium text-foreground-500 mb-1">微信公众号</span>
                <span className="text-sm text-foreground-900 font-medium">{contactData.wechat}</span>
              </div>

              <div className="flex flex-col items-center text-center p-5 rounded-lg">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 mb-3">
                  <i className="ri-qq-line text-xl"></i>
                </span>
                <span className="text-xs font-medium text-foreground-500 mb-1">QQ群</span>
                <span className="text-sm text-foreground-900 font-medium">{contactData.qq}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}